import { Injectable } from '@angular/core';
import { AppCommunicationService } from './app-communication.service';
import { Router } from '@angular/router';
import { FaqModel } from '../models/faq.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {
  getCreateFaqUrl,
  getDeleteFaqUrl,
  getEpcAllProjectsUrl,
  getEpcProjectCreateUrl, getEpcProjectDeleteUrl, getEpcProjectUpdateUrl,
  getFaqBySystemUrl,
  getUpdateFaqUrl,
} from '../app.urls';
import { AuthenticationService } from '../../core-frontend-common/auth/authentication.service';
import { EpcProjectModel } from '../models/epc-project.model';
import { BaseResponse } from '../models/base-response';

@Injectable()
export class EpcService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
  }

  getAllProjects(filter: any): Observable<BaseResponse<EpcProjectModel>> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    if (this.authenticationService.checkUser()) {
      return this.http
        .post(getEpcAllProjectsUrl(), filter, httpOptions)
        .pipe(map((res: any) => res.result as BaseResponse<EpcProjectModel>));
    }
  }

  createProject(project: EpcProjectModel): Observable<EpcProjectModel> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    if (this.authenticationService.checkUser()) {
      return this.http
        .post(getEpcProjectCreateUrl(), project, httpOptions)
        .pipe(map((res: any) => res.result as EpcProjectModel));
    }
  }

  updateProject(project: EpcProjectModel): Observable<EpcProjectModel> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    if (this.authenticationService.checkUser()) {
      return this.http
        .post(getEpcProjectUpdateUrl(), project, httpOptions)
        .pipe(map((res: any) => res.result as EpcProjectModel));
    }
  }

  deleteProject(project: EpcProjectModel): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${AppCommunicationService.getCurrentUser().access_token}`,
      }),
    };

    if (this.authenticationService.checkUser()) {
      return this.http
        .delete(getEpcProjectDeleteUrl(project.id), httpOptions)
        .pipe(map((res: any) => res));
    }
  }

}
